import React from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text, Row, Col } from "atomize";
import styled from "styled-components";
import trucateElipse from "../../../utils/truncateElipse";
import { NavLink } from "react-router-dom";
import ActivitiesIcon from "../ActivitiesIcon";

const Type = styled.p`
  font-family: Inter;
  font-weight: 600;
  font-size: 10px;
  color: ${theme.colors.gray};
  letter-spacing: 1.2px;
  line-height: 16px;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`;

const Title = styled.h1`
  font-family: Inter;
  font-weight: 700;
  font-size: 48px;
  color: ${theme.colors.dark};
  letter-spacing: 0;
  line-height: 58px;
`;

const Wrapper = styled(Div)`
  display: flex;
  margin: 3rem 0 2rem 0;
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;

const Content = styled(Div)`
  display: flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const IconWrapper = styled(Div)`
   margin-right: 2rem;
   @media (max-width: 550px) {
    margin-right: 0;
    margin-bottom: 1rem;
   }
`;

export default function ActivityHeader(props) {

  return (
    <Wrapper>
      <IconWrapper>
        <ActivitiesIcon
          type={props.type}
          color={props.color}
        />
      </IconWrapper>
      <Content>
        <Type>
          { props.type }
        </Type>
        <Title>
          { props.title }
        </Title>
      </Content>
    </Wrapper>
  )

};
